/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListDirectoryPeople } from "../funcs/accessListDirectoryPeople.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDirectoryPeopleResult } from "../models/components/listdirectorypeopleresult.js";
import {
  ListDirectoryPeopleRequest,
  ListDirectoryPeopleSecurity,
} from "../models/operations/listdirectorypeople.js";
import { unwrapAsync } from "../types/fp.js";
export type DirectoryPeopleQueryData = ListDirectoryPeopleResult;

export function prefetchDirectoryPeople(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDirectoryPeopleRequest | undefined,
  security?: ListDirectoryPeopleSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDirectoryPeopleQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDirectoryPeopleQuery(
  client$: GramCore,
  request?: ListDirectoryPeopleRequest | undefined,
  security?: ListDirectoryPeopleSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<DirectoryPeopleQueryData>;
} {
  return {
    queryKey: queryKeyDirectoryPeople({
      limit: request?.limit,
      cursor: request?.cursor,
      gramSession: request?.gramSession,
    }),
    queryFn: async function directoryPeopleQueryFn(
      ctx,
    ): Promise<DirectoryPeopleQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListDirectoryPeople(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDirectoryPeople(
  parameters: {
    limit?: number | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listDirectoryPeople", parameters];
}
